import React, { memo } from 'react';
import { type List as LobbyList, ListShape } from 'lib/LobbyEntities';
import type { Mapping } from '../Builder';
import ColumnList from './components/ColumnList';
import RowList from './components/RowList';

interface ListProps {
  entity: LobbyList;
  mapping: Mapping;
  position: number;
}

const List = ({ entity: list, mapping, position }: ListProps) => (
  <>
    {list.shape === ListShape.vertical && <ColumnList list={list} mapping={mapping} />}
    {list.shape === ListShape.row && <RowList list={list} mapping={mapping} position={position} />}
  </>
);

export default memo(List);
